import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./ChatAI.scss"
import QuickQuery from '../Copilot/QuickQuery';
import Conversation from './Conversation';
import useAuth from '../../hooks/useAuth';
import { MessageData } from '../../types/chat-bot-hub/MessageData';
import { quickQueryCards } from '../../types/chat-bot-hub/QuickQueryCards';
import { useTeamsAuth } from '../../hooks/useTeamsAuth';
import { recordingNetworkUsers } from '../../types/chat-bot-hub/recordingNetworkUsers';

interface NewChatProps {
  messages: MessageData[];
  sendTextToChatBot: (sessionId: string, isCancellationRequest: boolean, msg: string) => void;
  responseCompleted: boolean;
  quickQueryCards: quickQueryCards[];
  recordingNetworkDetails: recordingNetworkUsers|null;
  fetchLabelKeyTranslation : (key: string, defaultValue: string) => string;
}
const ChatAI: React.FC<NewChatProps> = ({ messages, sendTextToChatBot, responseCompleted, quickQueryCards, recordingNetworkDetails,fetchLabelKeyTranslation }) => {
  const [showConversation, setShowConversation] = useState(false);
  const [localInputText, setLocalInputText] = useState<string>("");
  const [localIsProcessing, setLocalIsProcessing] = useState(false);
  const auth = useAuth();
  const teamsAuth = useTeamsAuth();
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    if (responseCompleted) {
      setLocalIsProcessing(false);
    }
  }, [responseCompleted]);

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalInputText(event.target.value);
  }
  const handleQuickQuerySelect = (queryText: string) => {
    setLocalInputText(queryText);
  };
  const handleClick = () => {
    sendTextToChatBot("", localIsProcessing, localInputText);

    setLocalIsProcessing(!localIsProcessing);
    setShowConversation(true);
    setLocalInputText('');
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleClick();
    }
  };

  useLayoutEffect(() => {
  const textarea = textareaRef.current;
  const wrapper = wrapperRef.current;

  if (!textarea || !wrapper) return;

  const lineHeight = parseFloat(
    window.getComputedStyle(textarea).lineHeight
  );

  const maxLines = 5;
  const maxHeight = lineHeight * maxLines + 16;

  textarea.style.height = "auto";
  textarea.style.height =
    Math.min(textarea.scrollHeight, maxHeight) + "px";

  textarea.style.overflowY =
    textarea.scrollHeight > maxHeight ? "auto" : "hidden";
}, [localInputText]);

  return (
    <div>
      {showConversation ? <div className="chatwindow h-100">
        <Conversation messages={messages} sendTextToChatBot={sendTextToChatBot} responseCompleted={responseCompleted} fetchLabelKeyTranslation={fetchLabelKeyTranslation} />
      </div> :
        <div className="callListInner h-100 pb-3">
          <div className="chat-window">
            
            {recordingNetworkDetails &&
                recordingNetworkDetails?.licensedUsers === 0 && (
                  <div className="alert alert-primary" role="alert">
                    <i className="bi bi-info-circle mr-2"></i>
                    {fetchLabelKeyTranslation("CannotAccessDataOne","CIQpilot cannot access conversation data for users in your network as")} {" "}
                    {recordingNetworkDetails?.listenPermissionGranted === false
                      ? fetchLabelKeyTranslation("CannotAccessDataTwo","you do not have listen permissions.")
                      : fetchLabelKeyTranslation("CannotAccessDataThree","recorded users require an Ultimate IQ license.")}
                  </div>
                )}
            {recordingNetworkDetails && recordingNetworkDetails?.totalCount > 0 && recordingNetworkDetails?.totalCount === recordingNetworkDetails?.licensedUsers &&
              <div className="alert alert-primary" role="alert"><i className="bi bi-info-circle mr-2">
              </i>{fetchLabelKeyTranslation("CanAccessDataForAll","CIQpilot can access conversation data for all the users in your network.")}</div>}
            {recordingNetworkDetails && recordingNetworkDetails?.totalCount > 0 && recordingNetworkDetails?.licensedUsers > 0 && recordingNetworkDetails?.totalCount > recordingNetworkDetails?.licensedUsers &&
              <div className="alert alert-primary" role="alert"><i className="bi bi-info-circle mr-2">
              </i>{fetchLabelKeyTranslation("CanAccessDataForSomeOne","CIQpilot can access conversation data for")} {recordingNetworkDetails?.licensedUsers} {fetchLabelKeyTranslation("CanAccessDataForSomeTwo","out of")} {recordingNetworkDetails?.totalCount} {fetchLabelKeyTranslation("CanAccessDataForSomeThree","users in your network.")}</div>}
            <div className="row">
              <div className="col-md-12">
                <div className="welcomepanel d-flex justify-content-center text-center">
                  <div className="welcomelabel">
                    <h1 className="welcomeTitle"><i className="bi bi-stars text-primary mr-2"></i>{fetchLabelKeyTranslation("WelcomeTextOne","Welcome")} {(auth?.user?.firstName ?? teamsAuth?.firstName ?? "").trim()}, {fetchLabelKeyTranslation("WelcomeTextTwo","how can I help?")}</h1>
                    <h5 className="font-weight-normal text-muted mt-4">{fetchLabelKeyTranslation("WelcomeTextThree","CIQpilot analyzes your conversations to help you gain deeper business insights and optimize decision-making.")}</h5>
                  </div>
                </div>
                <div className="typingchat">
                  <div className="chatsection">
                    <form action="#" className="">
                      <div ref={wrapperRef} className="container mt-4 relative">
                        <div className="d-flex align-items-center shadowsm typingarea bg-white">
                          <textarea
                            ref={textareaRef}
                            rows={1}
                            value={localInputText}
                            className="form-control border-0 shadow-none ms-2 bg-transparent chat-textarea"
                            placeholder={fetchLabelKeyTranslation("AskAnythingPlaceholder","Ask anything.....")}
                            onChange={(e) => setLocalInputText(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleClick();
                              }
                            }}
                            disabled={localIsProcessing}
                          >
                          </textarea>
                          <button
                            type="button"
                            className="btn rounded-circle d-flex align-items-center justify-content-center me-1 chatbtn"
                            onClick={handleClick}
                            disabled={localIsProcessing}
                          >
                            {/* {!localIsProcessing ?<i className="bi bi-arrow-up text-white"></i> :
                            <i className="bi bi-stop-circle text-white"></i>} */}
                            <i className="bi bi-arrow-up text-white"></i>
                          </button>
                        </div>
                      </div>
                    </form>

                    {/* {messages.map((m, i) => {
                        return (
                            <>
                            {m.TextRequest && m.TextRequest !== "" &&
                                <div key={i} className="message user">
                                    {!m.IsCancelled && !m.IsErrored && !m.IsCompleted &&
                                        <div className="cursor-pointer m-r-5 m-t-10" onClick={() => sendTextToChatBot(m.RequestId, true)}>
                                            <i className="bi bi-stop-circle fs-20"></i>
                                        </div>
                                    }
                                     <div className="message-text">
                                      <Conversation/>
                                     </div>
                                     <div className="message-text">{m.TextRequest}</div> 
                                    <div className="m-t-10">
                                        {!m.IsCancelled && !m.IsErrored && !m.IsCompleted && <Loader className="m-l-5" themeColor={"primary"} size={"small"} type={"infinite-spinner"}/>}
                                        {m.IsCancelled && <i className="m-l-5 bi bi-pause-circle fs-20"></i>}
                                        {m.IsErrored && <i className="m-l-5 bi bi-x-circle fs-20"></i>}
                                        {m.IsCompleted && <i className="m-l-5 bi bi-check-circle fs-20"></i>}
                                    </div>
                                </div>
                            }
                            {m.TextResult.map((tr, j) =>{
                                return (
                                    <>
                                    {tr && tr !== "" &&
                                        <div key={j} className="message bot">
                                            <div className="message-text">{tr}</div>
                                        </div>
                                    }
                                    </>
                                )
                            })}
                            </>
                            
                        )
                    })} */}
                  </div>
                  <div className="container mt-4 suggest-section">
                    <QuickQuery onQuerySelect={handleQuickQuerySelect} quickQueryCards={quickQueryCards} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>

  );
};

export default ChatAI;
